import React from "react";
import styled from "styled-components";
import { Container, Stepper, Typography } from "@material-ui/core";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import MobileStepper from "@material-ui/core/MobileStepper";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Login from "../Layout/Login";
import CharacterData from "./CharacterData";
import Questions from "./Questions";
import Payment from "./Payment";
import useUser from "hooks/useUser";
import Rules from "./Rules";
import { WhitelistApplication, WhitelistApplicationRequest } from "lib/types/whitelist";
import Link from "next/link";

const Content = styled(Container)`
  display:flex;
  flex-direction: column;
  padding-top: 10vh;
`;

const LoginContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    text-align: center;
    font-size: 24px;
  }
`

const Title = styled(Typography).attrs({ as: 'h1' })`
  margin: 0 0 10px;
  font-size: 30px;
`

const Subtitle = styled(Typography)`
  margin: 0 0 20px;
  font-size: 18px;
`

const StyledStepper = styled(Stepper)`
  margin: 20px 0;
  padding: 20px 10px;
  background: #111;
  border-radius: 5px;

  span {
    font-size: 16px;
  }

  @media(max-width: 600px) {
    display: none;
  }
`

const StyledMobileStepper = styled(MobileStepper)`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 10px;
  background: #111;
  z-index: 1000;

  @media(min-width: 600px) {
    display: none;
  }
`

type Props = {
  whitelist?: WhitelistApplication;
  skipPayment?: boolean;
  onSend: (data: WhitelistApplicationRequest) => void;
}

type Answer = { question: string; answer: string };

export default function WhitelistForm({ whitelist, skipPayment, onSend }: Props) {
  const user = useUser();

  const [step, setStep] = React.useState<number>(0);

  const [characterName, setCharacterName] = React.useState<string>(whitelist?.characterName || '');
  const [characterAge, setCharacterAge] = React.useState<number>(whitelist?.characterAge || 0);
  // const [personality, setPersonality] = React.useState<string>(whitelist?.personality || '');
  const [biography, setBiography] = React.useState<string>(whitelist?.biography || '');
  const [streamer, setStreamer] = React.useState<string>(whitelist?.streamer || '');
  const [roleplayExperience, setRoleplayExperience] = React.useState<string>(whitelist?.roleplayExperience || '');
  const [rdmResponse, setRdmResponse] = React.useState<string>(whitelist?.rdmResponse || '');
  const [combatLogging, setCombatLogging] = React.useState<string>(whitelist?.combatLogging || '');
  const [roleplayAnswers, setRoleplayAnswers] = React.useState<Answer[]>(whitelist?.roleplayAnswers || []);
  const [rulesAnswers, setRulesAnswers] = React.useState<Answer[]>(whitelist?.rulesAnswers || []);

  React.useEffect(() => {
    document.getElementById('scroll-container')?.scrollTo({ top: 0, behavior: "smooth" });
  }, [step]);

  const nextStep = () => {
    setStep(current => current + 1);
  }

  const prevStep = () => {
    setStep(current => current - 1);
  }

  if (!user) {
    return (
      <Backdrop open>
        <CircularProgress color="primary" />
      </Backdrop>
    )
  }

  if (!user.logged) {
    return (
      <LoginContainer>
        <Subtitle>
          Para preencher o formulário, faça login com o
          Discord que receberá o cargo de aprovado.
        </Subtitle>
        <Login size="large" variant="contained" color="default" text="Conectar Discord" />
      </LoginContainer>
    )
  }

  return (
    <Content>
      <Title> Sua conta já <b>possúi allowlist</b> </Title>
      <Subtitle>
        No entanto, para garantir uma experiência justa e imersiva para todos, é essencial que você conheça e siga as regras e condutas do servidor. 
        <br /> Nosso objetivo é manter um ambiente saudável e uma comunidade unida no Velho Oeste.
        <br /><br />
        📜 Leia as regras aqui: <Link href={"https://infos.faroesterp.com"} target="_blank"> Regras e Condutas </Link>
        <br /><br />
        Se tiver dúvidas ou precisar de ajuda, nossa equipe e comunidade estão à disposição! 
        <br /><br />
        Nos vemos no Faroeste! 🤠🐎
      </Subtitle>
    </Content>
  )

  // return (
  //   <Content>
  //     <Title>Formulário para Allowlist</Title>
  //     <Subtitle>
  //       Esse é o formulário para ter a liberação de acesso ao servidor! <br />
  //       Essa allowlist aqui demora um pouquinho mais para ser lida, mas pode ficar relax que não vamos esquecer de você! <br />
  //     </Subtitle>
  //     <StyledMobileStepper
  //       variant="dots"
  //       steps={4}
  //       position="static"
  //       activeStep={step}
  //       nextButton={
  //         <Button size="small" onClick={() => nextStep()} disabled={step === 3}>
  //           Continuar
  //         </Button>
  //       }
  //       backButton={
  //         <Button size="small" onClick={() => prevStep()} disabled={step === 0}>
  //           Voltar
  //         </Button>
  //       }
  //     />
  //     <StyledStepper activeStep={step} alternativeLabel>
  //       <Step>
  //         <StepLabel>Personagem</StepLabel>
  //       </Step>
  //       <Step>
  //         <StepLabel>Questionário</StepLabel>
  //       </Step>
  //       <Step>
  //         <StepLabel>Regras</StepLabel>
  //       </Step>
  //       {!skipPayment && (
  //         <Step>
  //           <StepLabel>Confirmação</StepLabel>
  //         </Step>
  //       )}
  //     </StyledStepper>
  //     {step === 0 && (
  //       <CharacterData
  //         name={characterName}
  //         age={characterAge}
  //         // personality={personality}
  //         biography={biography}
  //         streamer={streamer}
  //         onBack={() => prevStep()}
  //         onContinue={(name: string, age: number, biography: string, streamer: string) => {
  //           setCharacterName(name);
  //           setCharacterAge(age);
  //           // setPersonality(personality);
  //           setBiography(biography);
  //           setStreamer(streamer);
  //           nextStep();
  //         }}
  //       />
  //     )}
  //     {step === 1 && (
  //       <Questions
  //         roleplayExperience={roleplayExperience}
  //         rdmResponse={rdmResponse}
  //         combatLogging={combatLogging}
  //         answers={roleplayAnswers}
  //         onBack={() => prevStep()}
  //         onContinue={(roleplayExperience: string, rdmResponse: string, combatLogging: string, answers: Answer[]) => {
  //           setRoleplayExperience(roleplayExperience);
  //           setRdmResponse(rdmResponse);
  //           setCombatLogging(combatLogging);
  //           setRoleplayAnswers(answers);
  //           nextStep();
  //         }}
  //       />
  //     )}
  //     {step === 2 && (
  //       <Rules
  //         answers={rulesAnswers}
  //         onBack={() => prevStep()}
  //         continueText={skipPayment ? 'Enviar' : 'Continuar'}
  //         onContinue={(answers: Answer[]) => {
  //           setRoleplayExperience(roleplayExperience);
  //           setRdmResponse(rdmResponse);
  //           setRulesAnswers(answers);
  //           setCombatLogging(combatLogging);

  //           if (skipPayment) onSend({
  //             characterName,
  //             characterAge,
  //             // personality,
  //             biography,
  //             streamer,
  //             roleplayExperience,
  //             rdmResponse,
  //             combatLogging,
  //             roleplayAnswers,
  //             rulesAnswers,
  //           });
  //           else nextStep();
  //         }}
  //       />
  //     )}
  //     {step === 3 && (
  //       <Payment
  //         onBack={() => prevStep()}
  //         onComplete={(donateAmount) => onSend({
  //           characterName,
  //           characterAge,
  //           // personality,
  //           biography,
  //           streamer,
  //           roleplayExperience,
  //           rdmResponse,
  //           combatLogging,
  //           roleplayAnswers,
  //           rulesAnswers,
  //           donateAmount,
  //         })}
  //       />
  //     )}
  //   </Content>
  // )
}
